window._drinkDrivingCalc = {
	stoneText: document.getElementById('stone-text-input'),
	poundsText: document.getElementById('pounds-text-input'),
	kilosText: document.getElementById('kilograms-text-input'),
	steppers: document.querySelectorAll('.stepper'),
	selects: document.querySelectorAll('select'),
	numInputs: document.querySelectorAll('input[type=number]'),
	radios: document.querySelectorAll('.field-group--indented-below input[type=radio]'),
	calcForm: document.querySelector('.calculator__form'),
	genderRadios: document.querySelector('.field-group--radios-gender'),
	calcBtn: document.querySelector('.calculator__results button'),

	toggleForm: (e, isHideForm) => {
		isHideForm && e.preventDefault();
		const heading = document.querySelector('.calculator__container h2');
		const form = document.querySelector('.calculator__form');
		const results = document.querySelector('.calculator__results');
		const timeLeft = document.querySelector('#timeLeft');

		if (isHideForm) {
			if (!_drinkDrivingCalc.validateForm()) return;
			const stoppedText = document.getElementById('stopped');
			const bacText = document.getElementById('bac');
			const highLowText = document.getElementById('highLow');
			const userMinute = +document.getElementById('minute').value;
			const userHour = document.getElementById('hour').value;
			let highLow;

			const bac = _drinkDrivingCalc.calculateBAC();

			const bacPercent = `${bac.toString()}%`;
			bacText.innerHTML = bacPercent;
			stoppedText.innerHTML = _drinkDrivingCalc.calculateStoppedDrinking();

			if (bac > 0.08) {
				highLow = 'higher than';
			} else if (bac == 0.08) {
				highLow = 'equal to';
			} else {
				highLow = 'lower than';
			}

			highLowText.innerHTML = highLow;
			const exampleDate = new Date();
			exampleDate.setHours(parseInt(userHour.substring(0, 2)), parseInt(userMinute), 0);
			exampleDate.setHours(exampleDate.getHours() + _drinkDrivingCalc.calculateTime());
			const amPm = exampleDate.getHours() >= 12 ? 'pm' : 'am';
			let timeString = exampleDate.toLocaleTimeString([], {
				hour: '2-digit',
				minute: '2-digit',
			});

			if (amPm === 'pm' && timeString.startsWith('0')) {
				timeString = timeString.substring(1);
			}

			timeLeft.innerHTML = `${_drinkDrivingCalc.calculateTime().toString()} hours at ${timeString
				.replace('AM', '')
				.replace('PM', '')
				.trimEnd()} ${amPm}`;
			heading.classList.add('large-heading');
			heading.innerHTML = 'Your results';
			form.classList.add('visuallyhidden');
			form.setAttribute('aria-hidden', 'true');
			results.classList.remove('visuallyhidden');
			results.removeAttribute('aria-hidden');

			document.querySelector('.calculator__container .large-heading').scrollIntoView({
				behavior: 'smooth',
			});
		} else {
			_drinkDrivingCalc.calcForm.reset();

			const stoneWrapper = document.getElementById('weight-option-wrapper--stone');
			stoneWrapper.parentElement.classList.add('display-none');
			stoneWrapper.classList.add('display-none');
			document.querySelector('.field-group--radios.active').classList.remove('active');
			document.getElementById('weight-option-wrapper--kilograms').classList.add('display-none');
			heading.classList.remove('large-heading');
			heading.innerHTML = "Enter a few details to see when it's safe to drive after drinking";
			results.classList.add('visuallyhidden');
			results.setAttribute('aria-hidden', 'true');
			form.classList.remove('visuallyhidden');
			form.removeAttribute('aria-hidden');
		}
	},

	calculateBAC: () => {
		const numberOfWineGrams = document.getElementById('wine').value * 2.1 * 8;
		const numberOfPintGrams = document.getElementById('pints').value * 2.3 * 8;
		const numberOfSpiritGrams = document.getElementById('spirits').value * 8;
		const totalAlcoholInGrams = +numberOfWineGrams + +numberOfPintGrams + +numberOfSpiritGrams;
		const genderConstant = document.getElementById('female').checked ? 0.55 : 0.68;
		const isKilos = document.getElementById('kilograms').checked;
		const weightObj = {};

		if (isKilos) {
			weightObj.kilos = document.getElementById('kilograms-text-input').value;
		} else {
			weightObj.stone = document.getElementById('stone-text-input').value;
			weightObj.pounds = document.getElementById('pounds-text-input').value;
		}

		const weight = _drinkDrivingCalc.weightToGrams(weightObj, isKilos);

		const BAC = ((totalAlcoholInGrams / (weight * genderConstant)) * 100).toFixed(2);
		return BAC;
	},

	calculateTime: () => {
		const numberOfUnits =
			+document.getElementById('wine').value * 2.1 +
			+document.getElementById('pints').value * 2.3 +
			+document.getElementById('spirits').value;
		return Math.ceil(+numberOfUnits + 1);
	},

	calculateStoppedDrinking: () => {
		const date = new Date();
		const userMinute = +document.getElementById('minute').value;
		const userHour = document.getElementById('hour').value;
		let hourDiff;
		let string;
		const timeStart = new Date(`01/01/2007 ${userHour}`).getHours();
		const hoursNow = date.getHours();
		const startDate = new Date('01/01/2007');
		const exampleDate = startDate.setHours(parseInt(userHour.substring(0, 2)), parseInt(userMinute), 0);
		const exampleDateTimeNow = startDate.setHours(date.getHours(), date.getMinutes(), 0);
		const diffMs = exampleDate - exampleDateTimeNow;
		const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);

		if (timeStart > hoursNow) {
			hourDiff = hoursNow - timeStart + 24;
		} else if (timeStart == hoursNow) {
			hourDiff = 0;
		} else {
			hourDiff = hoursNow - timeStart;
		}

		if (hourDiff === 1) {
			// 1 hour before current time
			if (userMinute > date.getMinutes()) {
				string = `${diffMins * -1} minutes ago`;
			} else if (userMinute === date.getMinutes()) {
				string = 'an hour ago';
			} else {
				if (diffMins === 1 || diffMins === -1) {
					string = `1 hour and ${diffMins * -1} minute ago`;
				} else {
					string = `1 hour and ${diffMins * -1} minutes ago`;
				}
			}
		} else if (hourDiff === 0) {
			// same hour as current time
			if (userMinute > date.getMinutes()) {
				string = `23 hours and ${60 - diffMins} minutes ago`;
			} else if (userMinute === date.getMinutes()) {
				string = 'just now';
			} else {
				if (diffMins === 1 || diffMins === -1) {
					string = `${diffMins * -1} minute ago`;
				} else {
					string = `${diffMins * -1} minutes ago`;
				}
			}
		} else {
			if (parseInt(userHour) > date.getHours()) {
				if (userMinute > date.getMinutes()) {
					if (diffMins == 0) {
						string = `${hourDiff - 1} hours ago`;
					} else if (diffMins === 1 || diffMins === -1) {
						string = `${hourDiff - 1} hours and ${diffMins * -1} minute ago`;
					} else {
						string = `${hourDiff - 1} hours and ${60 - diffMins} minutes ago`;
					}
				} else {
					if (diffMins == 0) {
						string = `${hourDiff} hours ago`;
					} else if (diffMins === 1) {
						string = `${hourDiff} hours and ${60 - diffMins} minutes ago`;
					} else if (diffMins === -1) {
						string = `${hourDiff} hours and ${diffMins * -1} minute ago`;
					} else {
						string = `${hourDiff} hours and ${60 - diffMins} minutes ago`;
					}
				}
			} else {
				if (userMinute > date.getMinutes()) {
					if (diffMins == 0) {
						string = `${hourDiff - 1} hours ago`;
					} else if (diffMins === 1 || diffMins === -1) {
						string = `${hourDiff - 1} hours and ${diffMins * -1} minute ago`;
					} else {
						string = `${hourDiff - 1} hours and ${diffMins * -1} minutes ago`;
					}
				} else {
					if (diffMins == 0) {
						string = `${hourDiff} hours ago`;
					} else if (diffMins === 1 || diffMins === -1) {
						string = `${hourDiff} hours and ${diffMins * -1} minute ago`;
					} else {
						string = `${hourDiff} hours and ${diffMins * -1} minutes ago`;
					}
				}
			}
		}

		return string;
	},

	weightToGrams: (weight, isKilos) => {
		let weightInGrams;

		if (isKilos) {
			weightInGrams = weight.kilos * 1000;
		} else {
			weightInGrams = ((+weight.stone + weight.pounds / 14) * 6.35).toFixed(2);
			weightInGrams *= 1000;
		}

		return weightInGrams;
	},

	setUpWeightRadios: radios => {
		const _loop = function _loop(i) {
			radios[i].addEventListener('change', function () {
				_drinkDrivingCalc.removeErrorStates(radios[i].closest('.field-group'));

				document.querySelector('.field-group--indented-below').classList.add('active');
				document.querySelector('.field-group--indented').classList.remove('display-none');
				const stoneWrapper = document.getElementById('weight-option-wrapper--stone');
				const kiloWrapper = document.getElementById('weight-option-wrapper--kilograms');

				if (this.getAttribute('id') === 'stone') {
					kiloWrapper.classList.add('display-none');
					stoneWrapper.classList.remove('display-none');
				} else {
					stoneWrapper.classList.add('display-none');
					kiloWrapper.classList.remove('display-none');
				}
			});
		};

		for (let i = 0; i < radios.length; i++) {
			_loop(i);
		}
	},

	numberInputStep: e => {
		e.preventDefault();

		_drinkDrivingCalc.removeErrorStates(document.querySelector('.drink').parentNode);

		const _this = e.target;

		const input = _this.parentNode.querySelector('input[type=number]');

		const currentVal = +input.value;
		let incVal;

		if (input.id == 'pints') {
			incVal = 0.5;
		} else {
			incVal = 1;
		}

		if (_this.classList.contains('plus')) {
			input.value = currentVal + incVal;
		} else {
			if (currentVal === 0) return;
			input.value = currentVal - incVal;
		}
	},

	validateForm: () => {
		let valid = true;

		if (!_drinkDrivingCalc.validateRadioInputs()) {
			valid = false;
		}

		if (!_drinkDrivingCalc.validateNumberInputs()) {
			valid = false;
		}

		if (!_drinkDrivingCalc.validateSelects()) {
			valid = false;
		}

		return valid;
	},

	validateRadioInputs: () => {
		const maleChecked = document.getElementById('male').checked;
		const femaleChecked = document.getElementById('female').checked;
		const stoneChecked = document.getElementById('stone').checked;
		const kilosChecked = document.getElementById('kilograms').checked;
		const radiosValid =
			((maleChecked && !femaleChecked) || (!maleChecked && femaleChecked)) &&
			((stoneChecked && !kilosChecked) || (!stoneChecked && kilosChecked));

		if (!maleChecked && !femaleChecked) {
			_drinkDrivingCalc.insertError(document.querySelector('.gender'));
		}

		if (!stoneChecked && !kilosChecked) {
			_drinkDrivingCalc.insertError(document.querySelector('.weight'));
		}

		if (stoneChecked) {
			if (_drinkDrivingCalc.stoneText.value == '' || _drinkDrivingCalc.poundsText.value == '') {
				_drinkDrivingCalc.insertError(document.querySelector('.weight'));

				[_drinkDrivingCalc.stoneText, _drinkDrivingCalc.poundsText].forEach(function (input) {
					if (input.value == '') {
						input.classList.add('validation--error');
					}
				});

				// set radio valid to false
				return (radiosValid = false);
			}

			if (_drinkDrivingCalc.poundsText.value > 13) {
				_drinkDrivingCalc.insertError(document.querySelector('.weight'));
				_drinkDrivingCalc.poundsText.classList.add('validation--error');
				return (radiosValid = false);
			}
		} else if (kilosChecked) {
			if (_drinkDrivingCalc.kilosText.value == '') {
				_drinkDrivingCalc.insertError(document.querySelector('.weight'));
				_drinkDrivingCalc.kilosText.classList.add('validation--error');
				return (radiosValid = false);
			}
		}

		if (radiosValid) {
			return true;
		} else {
			return false;
		}
	},

	validateNumberInputs: () => {
		let count = 0;
		const numberInputs = document.querySelectorAll('.field-group__stepper-container input[type=number]');

		for (let i = 0; i < numberInputs.length; i++) {
			if (numberInputs[i].value == 0) {
				count++;
			}
		}

		if (count == 3) {
			_drinkDrivingCalc.insertError(document.querySelector('.drink'));
			return false;
		} else {
			return true;
		}
	},

	validateSelects: () => {
		const hour = document.getElementById('hour');
		const minute = document.getElementById('minute');
		const hourValue = document.getElementById('hour').value;
		const minuteValue = document.getElementById('minute').value;

		if (hourValue == '' && minuteValue != '') {
			hour.classList.add('select--error');

			_drinkDrivingCalc.insertError(document.querySelector('.time'));

			return false;
		} else if (hourValue != '' && minuteValue == '') {
			minute.classList.add('select--error');

			_drinkDrivingCalc.insertError(document.querySelector('.time'));

			return false;
		} else if (hourValue == '' && minuteValue == '') {
			hour.classList.add('select--error');
			minute.classList.add('select--error');

			_drinkDrivingCalc.insertError(document.querySelector('.time'));

			return false;
		} else {
			return true;
		}
	},

	hasErrored: el => {
		const parent = el.parentNode;

		if (parent.querySelectorAll('.field-validation-error').length) {
			return true;
		} else {
			return false;
		}
	},

	insertError: el => {
		if (_drinkDrivingCalc.hasErrored(el)) return;
		const fieldValidationDiv = document.createElement('div');
		fieldValidationDiv.setAttribute('class', 'field-validation-error');
		const errorText = document.createElement('span');
		errorText.textContent = 'Please answer this question';
		const srErrorText = document.createElement('span');
		srErrorText.setAttribute('class', 'visually-hidden');
		srErrorText.textContent = 'Error';
		fieldValidationDiv.appendChild(srErrorText);
		fieldValidationDiv.appendChild(errorText);
		el.parentNode.insertBefore(fieldValidationDiv, el.nextSibling);
	},

	removeErrorStatesSelects: (e, el) => {
		const select = e.target;
		const hour = document.getElementById('hour');
		const minute = document.getElementById('minute');

		if (select.value != '') {
			select.classList.remove('select--error');
		}

		if ((hour.value != '') & (minute.value != '')) {
			_drinkDrivingCalc.removeErrorStates(el);
		}
	},

	removeErrorStates: el => {
		const errorMsg = el.querySelector('.field-validation-error');
		errorMsg && el.querySelector('.field-validation-error').remove();
	},

	stopNegNums: e => {
		if (e.keyCode == 189 || e.keyCode == 109) {
			e.preventDefault();
		}
	},
};

document.addEventListener('DOMContentLoaded', function () {
	for (let i = 0; i < _drinkDrivingCalc.steppers.length; i++) {
		_drinkDrivingCalc.steppers[i].addEventListener('click', _drinkDrivingCalc.numberInputStep);
	}

	for (let i = 0; i < _drinkDrivingCalc.selects.length; i++) {
		_drinkDrivingCalc.selects[i].addEventListener('change', function (e) {
			_drinkDrivingCalc.removeErrorStatesSelects(e, document.querySelector('.time').parentNode);
		});
	}

	[_drinkDrivingCalc.stoneText, _drinkDrivingCalc.poundsText].forEach(function (input) {
		input.addEventListener('change', function () {
			input.classList.remove('validation--error');

			if (_drinkDrivingCalc.stoneText.value != '' && _drinkDrivingCalc.poundsText.value != '') {
				_drinkDrivingCalc.removeErrorStates(document.querySelector('.field-group--indented-below'));
			}
		});
	});

	_drinkDrivingCalc.kilosText.addEventListener('change', function () {
		_drinkDrivingCalc.kilosText.classList.remove('validation--error');

		_drinkDrivingCalc.removeErrorStates(document.querySelector('.field-group--indented-below'));
	});

	for (let i = 0; i < _drinkDrivingCalc.numInputs.length; i++) {
		_drinkDrivingCalc.numInputs[i].addEventListener('keydown', function (e) {
			_drinkDrivingCalc.stopNegNums(e);
		});
	}

	_drinkDrivingCalc.calcForm.addEventListener('submit', function (e) {
		_drinkDrivingCalc.toggleForm(e, true);
	});

	_drinkDrivingCalc.calcBtn.addEventListener('click', function (e) {
		_drinkDrivingCalc.toggleForm(e, false);
	});

	_drinkDrivingCalc.genderRadios.addEventListener('change', function (e) {
		_drinkDrivingCalc.removeErrorStates(e.target.closest('.field-group'));
	});

	_drinkDrivingCalc.setUpWeightRadios(_drinkDrivingCalc.radios);
});
